export enum DocumentFileType {
  ORIGINAL = 'ORIGINAL',
  SIGNED = 'SIGNED',
  SIGNATURE = 'SIGNATURE',
  REPORT = 'REPORT',
  ARCHIVE = 'ARCHIVE',
  PRINT = 'PRINT',
}
